import * as types from './types'
import storage from '@/plugins/storage'
export default {
  [types.RESET_LOGIN](state) {
    state.token = null
    state.profile = null
    storage.session.setItem(types.SESSION_TOKEN_NAME, null)
    storage.session.setItem(types.SESSION_PROFILE, null)
  },
  [types.SET_TOKEN](state, data) {
    state.token = data.access_token
    storage.session.setItem(types.SESSION_TOKEN_NAME, data.access_token)
    storage.session.setItem(types.SESSION_PROFILE, JSON.stringify(data))
  },
  [types.SET_SEARCH_TERM](state, text) {
    state.searchTerm = text
  },
  [types.SET_COMPONENTS](state, data) {
    state.components = []
    if (data) {
      if (data._embedded) {
        if (data._embedded.data) {
          state.components = data._embedded.data.components
        }
      }
    }
    console.log('Got Components', state.components)
  },
  [types.SET_VIN](state, vin) {
    state.vin = vin
  },
  [types.SET_VEHICLE](state, data) {
    state.vehicle = data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/alldata/mutations.js